import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import { SolutionModelProvider } from '../contexts/SolutionModelContext';
import { SnackbarProvider } from '../components/common_modules/SnackbarContext';
import { UserJourneyGuideProvider } from '../contexts/UserJourneyGuideContext';
import { ProductTourProvider } from '../contexts/ProductTourContext';
import { AutoLoginWrapper, OAuthRedirectHandler } from '../auth/AuthRoutingHelpers';
import AutoLogoutListener from '../components/AutoLogoutListener';

/**
 * Shared V1-style provider stack + HashRouter + OAuth/auto-login wrappers.
 * Pass the route gate as children (e.g. AppRoutesGate or AppRoutesGateV1Only).
 */
function AppProvidersShell({ children }) {
  return (
    <SnackbarProvider>
      <SolutionModelProvider>
        <UserJourneyGuideProvider>
          <ProductTourProvider>
            <Router>
              <AutoLogoutListener />
              <OAuthRedirectHandler />
              <AutoLoginWrapper />
              {children}
            </Router>
          </ProductTourProvider>
        </UserJourneyGuideProvider>
      </SolutionModelProvider>
    </SnackbarProvider>
  );
}

export default AppProvidersShell;
